import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const MatasPlusDetailsQuickViewAtom = mediatorAtom<{
    isOpen: boolean;
}>({
    isOpen: false
});

export default function useMatasPlusDetailsQuickView() {
    return useMediatorState(MatasPlusDetailsQuickViewAtom);
}
